<template>
  <padding size="large">
    <div class="flex__column">
      <div class="flex__row flex--middle">
        <div class="flex__column flex--100">
          <h4>Notifications</h4>
        </div>
        <div class="flex__column">
          <close-button size="small" id="notifications-close-button" @click="close"/>
        </div>
      </div>

      <padding direction="top" size="medium"/>

      <table-loading-placeholder v-if="!loadComplete" :row-count="3" row-height="43" gutter-size="10"/>

      <notifications-list @close="close"/>
      <div v-if="loadComplete && notificationCount === 0" class="flex__row flex--middle">
        <icon icon="notifications" colour="secondary"/>
        <padding direction="left">
          <p>You have no notifications</p>
        </padding>
      </div>
    </div>
  </padding>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { path } from 'ramda'
import CloseButton from '../Buttons/CloseButton'
import Padding from '../Utils/Padding'
import NotificationsList from './NotificationsList'
import Icon from '../Icon'
import TableLoadingPlaceholder from '../Utils/TableLoadingPlaceholder'

export default {
  name: 'NotificationsModal',
  components: { TableLoadingPlaceholder, Icon, NotificationsList, Padding, CloseButton },
  computed: {
    ...mapState(
      {
        loadComplete: path(['notifications', 'loaded']),
        notifications: path(['notifications', 'entities']),
      },
    ),
    notificationCount() {
      return this.notifications.length
    },
  },
  methods: {
    ...mapActions(
      {
        close: 'localModal/close',
      },
    ),
  },
}
</script>
